// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M2.009 5.29c-.217.078-.418.281-.476.482a.937.937 0 0 0 .022.522.9.9 0 0 0 .327.366.894.894 0 0 0 .254.082c.219.036 19.51.036 19.728 0a.729.729 0 0 0 .63-.715c0-.087-.011-.202-.027-.255-.06-.207-.292-.433-.506-.492-.055-.015-3.573-.023-9.973-.023-8.255 0-9.903.006-9.98.034m0 6c-.216.077-.417.28-.475.481a.937.937 0 0 0 .022.522.9.9 0 0 0 .327.366.894.894 0 0 0 .254.082c.219.036 19.51.036 19.728 0a.729.729 0 0 0 .63-.715c0-.087-.011-.202-.027-.255-.06-.207-.292-.433-.506-.492-.055-.015-3.573-.023-9.973-.023-8.255 0-9.903.006-9.98.034m0 6c-.216.077-.417.28-.475.481a.937.937 0 0 0 .022.522.9.9 0 0 0 .327.366.894.894 0 0 0 .254.082c.219.036 19.51.036 19.728 0a.729.729 0 0 0 .63-.715c0-.087-.011-.202-.027-.255-.06-.207-.292-.433-.506-.492-.055-.015-3.573-.023-9.973-.023-8.255 0-9.903.006-9.98.034"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const NavigationMenuIcon = Icon;
export default NavigationMenuIcon;
